function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#53a551",
    viewBox: "25.6 25.6 213.33 204.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M15 3C8.373 3 3 8.373 3 15s5.373 12 12 12 12-5.373 12-12c0-2.18-.59-4.217-1.605-5.979L14.146 20.268a1 1 0 0 1-1.414 0L8.28 15.814A.999.999 0 1 1 9.693 14.4l3.746 3.746 10.801-10.8A11.97 11.97 0 0 0 15 3zm9.24 4.346c.432.52.814 1.084 1.155 1.674l2.312-2.313a.999.999 0 1 0-1.414-1.414z",
    fontFamily: "none",
    fontSize: "none",
    fontWeight: "none",
    style: {
      mixBlendMode: "normal"
    },
    textAnchor: "none",
    transform: "scale(8.53333)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.af06411843b0544eaf00844eddc4243c.svg";
export { ForwardRef as ReactComponent };